"use client";

import { useLang } from "@/hooks/use-lang";
import { useUpdateQuery } from "@/hooks/use-update-query";

import { ButtonGroup } from "ui/core/button-group";

import { ValueFactorInterval, getIntervalButtonsData } from "../data/intervals";

type Props = {
  interval?: ValueFactorInterval;
};

export const ValueFactorIntervalButtons = ({ interval }: Props) => {
  const { t } = useLang();
  const intervals = getIntervalButtonsData({ t });
  const currentInterval = interval ?? intervals[0].id;

  const { updateQuery } = useUpdateQuery();
  const onClick = (value: string) => {
    updateQuery({ name: "interval", value });
  };

  return (
    <ButtonGroup
      options={intervals}
      activeId={currentInterval}
      onButtonClick={onClick}
    />
  );
};
